import type { ComposeFormStore } from 'owa-calendar-compose-types';
import { logUsage } from 'owa-analytics';
import { getComposeStoreManager } from '../store/store';

export function getComposeStore(formId: string): ComposeFormStore | undefined {
    const store = getComposeStoreInternal(formId);

    if (!store) {
        logUsage('CalendarComposeStoreNotFound');
    }

    return store;
}

export function isComposeStoreAvailable(formId: string): boolean {
    return !!getComposeStoreInternal(formId);
}

export function getComposeStoreInternal(formId: string): ComposeFormStore | undefined {
    return getComposeStoreManager().storeMap.get(formId);
}
